import React, { useState } from 'react';
import { tt } from '@i18n/tt';

import { ReactComponent as ArrowIcon } from 'assets/arrowForward.icon.svg';
import { ReactComponent as TicketIcon } from 'assets/ticket.svg';

import CreateChatArea from './CreateChatArea';
import Button from 'components/Button/Button';
import TechnicianVerification from 'components/Layout/components/TechnicianVerification';

import useStyles from '../styles';
import CreateTicketDialog from 'components/CreateTicketDialog';

const HomePageTiles: React.FC = () => {
  const [openTicketCreationDialog, setOpenTicketCreationDialog] = useState(false);
  const classes = useStyles();

  return (
    <div className={classes.homePageTiles}>
      <div className={classes.homePageTile}>
          <Button
            text={tt('pages.home.ticketCard.button')}
            onClick={() => {
              setOpenTicketCreationDialog(true);
            }}
            startIcon={<TicketIcon />}
            endIcon={<ArrowIcon />}
            variant="text"
            fullWidth
            className={classes.button}
          />
      </div>

      <CreateChatArea />

      <div className={classes.homePageTile}>
        <div className={classes.text}>
          <TechnicianVerification showAsButton />
        </div>
      </div>

      {openTicketCreationDialog && (
        <CreateTicketDialog
          open={openTicketCreationDialog}
          onClose={() => {
            setOpenTicketCreationDialog(false);
          }}
        />
      )}
    </div>
  );
};

export default HomePageTiles;
